export const METRICS_MIN_DATE = new Date(2022, 0, 1)
export const METRICS_MAX_DATE = new Date()
